import {createDomain} from 'effector';
import {createGate} from 'effector-react';

export const rootDomain = createDomain('createInvoiceNewDomain');

export const CreateInvoiceGate = createGate('CreateInvoiceGate');
export const GeneralInfoGate = createGate('GeneralInfo');
export const DocumentsGate = createGate('Documents');
export const InvoiceGeneratingGate = createGate('InvoiceGenerating');
export const TaxesAndTotalGate = createGate('Taxes');

export const doCloseAllGates = rootDomain.createEvent();
doCloseAllGates.watch(() => {
    CreateInvoiceGate.close();
    GeneralInfoGate.close();
    DocumentsGate.close();
    InvoiceGeneratingGate.close();
    TaxesAndTotalGate.close();
});
